import { all } from 'redux-saga/effects';
import appSagas from './app/sagas';
import authSagas from './auth/saga';
import dashboardSagas from "./dashboard/sagas";
import confirmSagas from './confirm/sagas';
// import propertySagas from "./properties/sagas";
import property2Sagas from "./properties2/sagas";
import propertyAdvertiseSagas from "./propertiesAdvertise/sagas";
import propertySubscribeSagas from "./propertiesSubscribe/sagas";
import propertyTenancyAgreementSagas from './propertiesTenancyAgreements/sagas';
import tenantSagas from "./tenants/sagas";
import issuesSagas from './issues/sagas';
import mailSagas from './mail/saga';
import calendarSagas from './calendar/sagas';
import rentVerificationSagas from './outstandingRentVerifications/sagas';
import cancelSubscriptionSagas from './cancelSubscription/sagas';

export default function* rootSaga(getState) {
	yield all([
		appSagas(),
		authSagas(),
		dashboardSagas(),
		confirmSagas(),
		// propertySagas(),
		property2Sagas(),
		propertyAdvertiseSagas(),
		propertySubscribeSagas(),
		propertyTenancyAgreementSagas(),
		tenantSagas(),
		issuesSagas(),
		mailSagas(),
		calendarSagas(),
		rentVerificationSagas(),
		cancelSubscriptionSagas(),
	]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas.js